<style>
.divider-col {
  margin-top: 0 !important;
}

hr.style1 {
  border-top: 1px solid #8c8b8b;
}

.hr-sect {
  display: flex;
  flex-basis: 100%;
  align-items: center;
  color: rgba(0, 0, 0, 1);
  margin: 10px 0px;
  font-size: 15px;
}

.hr-sect:before,
.hr-sect:after {
  content: "";
  flex-grow: 1;
  background: rgba(0, 0, 0, 0.35);
  height: 1px;
  font-size: 0px;
  line-height: 0px;
  margin: 0px 0px;
}
</style>
<template>
  <b-row>
    <b-col xl="12" lg="12">
      <Widget title="
          <div>
            <h4>
              Verifikasi Dokumen
            </h4>
          </div>" customHeader close collapse>
        <form-wizard shape="tab" color="#3498db" title="" subtitle="" @on-change="updateProgress"
          @on-loading="updateProgress(1, 1)">
          <b-progress class="progress-xs" variant="info" :value="progress" :max="2" />
          <b-button slot="prev" variant="primary" id="back" hidden class="text-white">
            <i class="fa fa-caret-left" /> Sebelumnya
          </b-button>
          <b-button slot="next" variant="primary" id="next" hidden class="text-white">
            Selanjutnya <i class="fa fa-caret-right" />
          </b-button>
          <b-button @click="$router.push('/app/notifikasi-izin-lokasi')" slot="finish" variant="success" id="finish" hidden
            class="text-white">
            Selesai <i class="fa fa-check" />
          </b-button>
          <tab-content title="1. Profil">
            <Profil @nextDokumen="nextDokumen" :dataPermohonan="dataPermohonan" :dataKBLI="dataKBLI"
              :dataKlasifikasi="dataKlasifikasi"></Profil>
            <!-- <div class="row justify-content-between">
              <div class="col-4">
                <div class="text-left">
                  <b-button @click="$router.push('/app/perizinan')" variant="danger">Back</b-button>
                </div>
              </div>
              <div class="col-4">
                <div class="text-right">
                  <b-button @click="simpanProfil()" style="float: right" variant="primary">Selanjutnya <i
                      class="fa fa-caret-right" />
                  </b-button>
                </div>
              </div>
            </div> -->
          </tab-content>
          <tab-content title="2. Dokumen">
            <b-form>
              <b-row>
                <b-col md="5">
                  <p style="font-weight: 900; font-size: 17px">Koordinat</p>
                </b-col>
                <b-col md="3">
                  <b-form-group class="float-end">
                    <b-form-file ref="fileInput" class="d-none" v-model="file_1" accept=".doc, .docx, .xlsx, .pdf"
                      @input="simpanKordinat"></b-form-file>

                    <b-button variant="secondary" @click="$refs.fileInput.$el.querySelector('input').click()"
                      class="text-white" size="sm">
                      <i class="fa fa-upload"></i> Unggah File
                    </b-button>
                  </b-form-group>
                </b-col>
                <template v-if="dataPermohonan.file_kordinat == null">
                  <b-col md="4">
                    <b-button variant="primary" @click="sinkronisasiDokumen(id_file_kordinat, 'file_kordinat')"
                      class="text-white" style="margin-right: 5px" size="sm"><i class="fa fa-repeat" /> Sinkronisasi
                      Dokumen
                      OSS</b-button>
                  </b-col>
                </template>

                <template v-else>
                  <b-col md="4">
                    <b-form-group>

                      <b-button variant="primary" @click="sinkronisasiDokumen(id_file_kordinat, 'file_kordinat')"
                        class="text-white" style="margin-right: 5px" size="sm"><i class="fa fa-repeat" /> Sinkronisasi
                        Dokumen
                        OSS</b-button>

                      <b-button variant="success" v-if="dataPermohonan.file_kordinat == null" disabled
                        data-toggle="tooltip" data-placement="top" title="Tidak ada data" class="text-white"
                        style="margin-right: 5px" size="sm"><i class="fa fa-download" /> Download</b-button>
                      <a :href="dataPermohonan.file_kordinat" v-else type="button" class="btn btn-success btn-sm"
                        target="_blank" rel="noopener noreferrer"><i class="fa fa-download" /> Download</a>

                    </b-form-group>
                  </b-col>
                </template>
                <div class="divider div-transparent"></div>
                <b-col md="5">
                  <p style="font-weight: 900; font-size: 17px">
                    Rencana Bangunan dan Instalasi di Laut
                  </p>
                </b-col>
                <b-col md="3">
                  <b-form-group class="float-end">
                    <b-form-file ref="fileInput2" class="d-none" v-model="file_2" accept=".doc, .docx, .xlsx, .pdf"
                      @input="simpanBangunan"></b-form-file>

                    <b-button variant="secondary" @click="$refs.fileInput2.$el.querySelector('input').click()"
                      class="text-white" size="sm">
                      <i class="fa fa-upload"></i> Unggah File
                    </b-button>
                  </b-form-group>
                </b-col>
                <template v-if="dataPermohonan.file_rencana_bangunan_dan_instalasi_di_laut == null">
                  <b-col md="4">
                    <b-button variant="primary"
                      @click="sinkronisasiDokumen(id_file_rencana_bangunan_dan_instalasi_di_laut, 'file_rencana_bangunan_dan_instalasi_di_laut')"
                      class="text-white" style="margin-right: 5px" size="sm"><i class="fa fa-repeat" /> Sinkronisasi
                      Dokumen OSS</b-button>
                  </b-col>
                </template>
                <template v-else>

                  <b-col md="4">

                    <b-button variant="primary"
                      @click="sinkronisasiDokumen(id_file_rencana_bangunan_dan_instalasi_di_laut, 'file_rencana_bangunan_dan_instalasi_di_laut')"
                      class="text-white" style="margin-right: 5px" size="sm"><i class="fa fa-repeat" /> Sinkronisasi
                      Dokumen OSS</b-button>
                    <!-- <b-button
                    variant="primary"
                    v-if="file_2 == null"
                    disabled
                    @click="simpanBangunan()"
                    class="text-white"
                    style="margin-right: 5px"
                    ><i class="fa fa-cloud-upload" /> Unggah</b-button
                  >
                  <b-button
                    variant="primary"
                    v-else
                    @click="simpanBangunan()"
                    class="text-white"
                    style="margin-right: 5px"
                    ><i class="fa fa-cloud-upload" /> Unggah</b-button
                  > -->
                    <!-- <b-button variant="success" v-if="dataPermohonan.file_rencana_bangunan_dan_instalasi_di_laut != null" class="text-white" style="margin-right:5px"><i class="fa fa-download"/> Download</b-button> -->
                    <b-button variant="success" v-if="
                      dataPermohonan.file_rencana_bangunan_dan_instalasi_di_laut ==
                      null
                    " disabled data-toggle="tooltip" data-placement="top" title="Tidak ada data" class="text-white"
                      style="margin-right: 5px" size="sm"><i class="fa fa-download" /> Download</b-button>
                    <a :href="dataPermohonan.file_rencana_bangunan_dan_instalasi_di_laut
                      " v-else type="button" class="btn btn-success btn-sm" target="_blank"
                      rel="noopener noreferrer"><i class="fa fa-download" /> Download</a>

                  </b-col>
                </template>
                <!-- <b-col md="12" class="divider-col">
                            <hr class="style1 hr-blurry" md="12">
                        </b-col> -->
                <b-col md="12">
                  <div class="hr-sect">Rencana Kegiatan</div>
                </b-col>
                <!-- <b-col md="3">
                        
                        </b-col>
                        <b-col md="4">
                        
                        </b-col> -->
                <!-- <b-col md="12" class="divider-col">
                            <hr class="style1" md="12">
                        </b-col> -->

                <b-col md="8">
                  <div>
                    Dokumen dasar berupa kegiatan, tujuan dan manfaat kegiatan
                    usaha
                  </div>
                </b-col>
                <!-- <b-col md="3">
                            <b-form-group>
                                <b-form-file
                                placeholder="Choose a file or drop it here..."
                                drop-placeholder="Drop file here..."
                                plain
                                class="form-control"
                                ></b-form-file>
                            </b-form-group>
                        </b-col> -->
                <b-col md="3">
                  <!-- <b-form-group> -->
                  <!-- <b-button variant="primary" class="text-white" style="margin-right:5px"><i class="fa fa-cloud-upload"/> Unggah</b-button>
                                <b-button variant="success" class="text-white" style="margin-right:5px"><i class="fa fa-download"/> Download</b-button> -->
                  <div class="form-check form-switch">
                    <input v-model="dataPermohonan.verifikasi_dokumen_dasar"
                      @change="simpanIndikator('verifikasi_dokumen_dasar')" class="form-check-input" type="checkbox"
                      id="flexSwitchCheckDefault" />
                    <label class="form-check-label" for="flexSwitchCheckDefault">{{
                      dataPermohonan.verifikasi_dokumen_dasar
                        ? "Sesuai"
                        : "TIdak Sesuai"
                    }}</label>
                  </div>
                  <!-- </b-form-group> -->
                </b-col>
                <b-col md="1">
                  <b-button style="border-radius: 50px" variant="info" size="sm" title="Catatan"
                    v-b-modal.modal-keterangan @click="keterangan = dataPermohonan.verifikasi_dokumen_dasar_keterangan">
                    <i class="fa fa-file"></i>
                  </b-button>
                </b-col>
                <b-col md="12" class="divider-col">
                  <hr class="style1" md="12" />
                </b-col>

                <b-col md="5">
                  <div>Kegiatan eksisting yang dimohonkan</div>
                </b-col>
                <b-col md="3">
                  <!-- <b-form-group>
                                <b-form-file
                                placeholder="Choose a file or drop it here..."
                                drop-placeholder="Drop file here..."
                                plain
                                class="form-control"
                                ></b-form-file>
                            </b-form-group> -->
                </b-col>
                <b-col md="3">
                  <!-- <b-form-group> -->
                  <!-- <b-button variant="primary" class="text-white" style="margin-right:5px"><i class="fa fa-cloud-upload"/> Unggah</b-button>
                                <b-button variant="success" class="text-white" style="margin-right:5px"><i class="fa fa-download"/> Download</b-button> -->
                  <div class="form-check form-switch">
                    <input v-model="dataPermohonan.verifikasi_kegiatan_eksisting"
                      @change="simpanIndikator('verifikasi_kegiatan_eksisting')" class="form-check-input"
                      type="checkbox" id="flexSwitchCheckDefault2" />
                    <label class="form-check-label" for="flexSwitchCheckDefault2">{{
                      dataPermohonan.verifikasi_kegiatan_eksisting
                        ? "Sesuai"
                        : "Tidak Sesuai"
                    }}</label>
                  </div>
                  <!-- </b-form-group> -->
                </b-col>
                <b-col md="1">
                  <b-button style="border-radius: 50px" variant="info" size="sm" title="Catatan"
                    v-b-modal.modal-keterangan
                    @click="keterangan = dataPermohonan.verifikasi_kegiatan_eksisting_keterangan">
                    <i class="fa fa-file"></i>
                  </b-button>
                </b-col>
                <b-col md="12" class="divider-col">
                  <hr class="style1" md="12" />
                </b-col>
                <b-col md="8">
                  <div>
                    Rencana jadwal pelaksanaan kegiatan utama dan pendukungnya
                  </div>
                </b-col>
                <!-- <b-col md="3">
                            <b-form-group>
                                <b-form-file
                                placeholder="Choose a file or drop it here..."
                                drop-placeholder="Drop file here..."
                                plain
                                class="form-control"
                                ></b-form-file>
                            </b-form-group>
                        </b-col> -->
                <b-col md="3">
                  <!-- <b-form-group> -->
                  <!-- <b-button variant="primary" class="text-white" style="margin-right:5px"><i class="fa fa-cloud-upload"/> Unggah</b-button>
                                <b-button variant="success" class="text-white" style="margin-right:5px"><i class="fa fa-download"/> Download</b-button> -->
                  <div class="form-check form-switch">
                    <input v-model="dataPermohonan.verifikasi_rencana_jadwal"
                      @change="simpanIndikator('verifikasi_rencana_jadwal')" class="form-check-input" type="checkbox"
                      id="flexSwitchCheckDefault3" />
                    <label class="form-check-label" for="flexSwitchCheckDefault3">{{
                      dataPermohonan.verifikasi_rencana_jadwal
                        ? "Sesuai"
                        : "Tidak Sesuai"
                    }}</label>
                  </div>
                  <!-- </b-form-group> -->
                </b-col>
                <b-col md="1">
                  <b-button style="border-radius: 50px" variant="info" size="sm" title="Catatan"
                    v-b-modal.modal-keterangan
                    @click="keterangan = dataPermohonan.verifikasi_rencana_jadwal_keterangan">
                    <i class="fa fa-file"></i>
                  </b-button>
                </b-col>
                <b-col md="12" class="divider-col">
                  <hr class="style1" md="12" />
                </b-col>
                <b-col md="8">
                  <div>
                    Rencana tapak/site plan kegiatan yang dilengkapi dengan
                    rencana bangunan dan instalasi di laut serta fasilitas
                    penunjangnya
                  </div>
                </b-col>
                <!-- <b-col md="3"> -->
                <!-- <b-form-group>
                                <b-form-file
                                placeholder="Choose a file or drop it here..."
                                drop-placeholder="Drop file here..."
                                plain
                                class="form-control"
                                ></b-form-file>
                            </b-form-group> -->
                <!-- </b-col> -->
                <b-col md="3">
                  <!-- <b-form-group> -->
                  <!-- <b-button variant="primary" class="text-white" style="margin-right:5px"><i class="fa fa-cloud-upload"/> Unggah</b-button>
                                <b-button variant="success" class="text-white" style="margin-right:5px"><i class="fa fa-download"/> Download</b-button> -->
                  <div class="form-check form-switch">
                    <input v-model="dataPermohonan.verifikasi_rencana_site_plan"
                      @change="simpanIndikator('verifikasi_rencana_site_plan')" class="form-check-input" type="checkbox"
                      id="flexSwitchCheckDefault4" />
                    <label class="form-check-label" for="flexSwitchCheckDefault4">{{
                      dataPermohonan.verifikasi_rencana_site_plan
                        ? "Sesuai"
                        : "Tidak Sesuai"
                    }}</label>
                  </div>
                  <!-- </b-form-group> -->
                </b-col>
                <b-col md="1">
                  <b-button style="border-radius: 50px" variant="info" size="sm" title="Catatan"
                    v-b-modal.modal-keterangan
                    @click="keterangan = dataPermohonan.verifikasi_rencana_site_plan_keterangan">
                    <i class="fa fa-file"></i>
                  </b-button>
                </b-col>
                <b-col md="12" class="divider-col">
                  <hr class="style1" md="12" />
                </b-col>
                <b-col md="8">
                  <div>
                    Deksriptif luasan (Ha) yang dibutuhkan pada lokasi usaha
                    yang dimohonkan per kegiatan utama dan penunjangnya
                  </div>
                </b-col>
                <!-- <b-col md="3">
                            <b-form-group> -->
                <!-- <b-form-file
                                placeholder="Choose a file or drop it here..."
                                drop-placeholder="Drop file here..."
                                plain
                                class="form-control"
                                ></b-form-file> -->
                <!-- </b-form-group>
                        </b-col> -->
                <b-col md="3">
                  <!-- <b-form-group> -->
                  <!-- <b-button variant="primary" class="text-white" style="margin-right:5px"><i class="fa fa-cloud-upload"/> Unggah</b-button>
                                <b-button variant="success" class="text-white" style="margin-right:5px"><i class="fa fa-download"/> Download</b-button> -->
                  <div class="form-check form-switch">
                    <input v-model="dataPermohonan.verifikasi_deskriptif_luasan"
                      @change="simpanIndikator('verifikasi_deskriptif_luasan')" class="form-check-input" type="checkbox"
                      id="flexSwitchCheckDefault5" />
                    <label class="form-check-label" for="flexSwitchCheckDefault5">{{
                      dataPermohonan.verifikasi_deskriptif_luasan
                        ? "Sesuai"
                        : "Tidak Sesuai"
                    }}</label>
                  </div>
                  <!-- </b-form-group> -->
                </b-col>
                <b-col md="1">
                  <b-button style="border-radius: 50px" variant="info" size="sm" title="Catatan"
                    v-b-modal.modal-keterangan
                    @click="keterangan = dataPermohonan.verifikasi_deskriptif_luasan_keterangan">
                    <i class="fa fa-file"></i>
                  </b-button>
                </b-col>
                <b-col md="12" class="divider-col">
                  <hr class="style1" md="12" />
                </b-col>
                <b-col md="8">
                  <div>
                    Peta lokasi/plotting batas-batas area dan/atau jalur
                    disertai titik koordinat lokasi dengan sistem koordinat
                    lintang (latitude) dan bujur (longitude) berskala minimal
                    1:50.000.
                  </div>
                </b-col>

                <b-col md="3">
                  <!-- <b-form-group> -->
                  <div class="form-check form-switch">
                    <input v-model="dataPermohonan.verifikasi_peta_lokasi"
                      @change="simpanIndikator('verifikasi_peta_lokasi')" class="form-check-input" type="checkbox"
                      id="flexSwitchCheckDefault6" />
                    <label class="form-check-label" for="flexSwitchCheckDefault6">{{
                      dataPermohonan.verifikasi_peta_lokasi
                        ? "Sesuai"
                        : "Tidak Sesuai"
                    }}</label>
                  </div>
                  <!-- </b-form-group> -->
                </b-col>
                <b-col md="1">
                  <b-button style="border-radius: 50px" variant="info" size="sm" title="Catatan"
                    v-b-modal.modal-keterangan @click="keterangan = dataPermohonan.verifikasi_peta_lokasi_keterangan">
                    <i class="fa fa-file"></i>
                  </b-button>
                </b-col>
                <b-col md="12" class="divider-col">
                  <hr class="style1" md="12" />
                </b-col>
                <b-col md="5">
                  <div>
                    <p style="font-weight: 900; font-size: 17px">
                      Informasi Pemanfaatan Ruang Laut
                    </p>
                  </div>
                </b-col>
                <b-col md="3">
                  <b-form-group class="float-end">
                    <b-form-file ref="fileInput3" class="d-none" v-model="file_3" accept=".doc, .docx, .xlsx, .pdf"
                      @input="simpanPRL"></b-form-file>

                    <b-button variant="secondary" @click="$refs.fileInput3.$el.querySelector('input').click()"
                      class="text-white" size="sm">
                      <i class="fa fa-upload"></i> Unggah File
                    </b-button>
                  </b-form-group>
                </b-col>
                <template v-if="dataPermohonan.file_informasi_prl == null">
                  <b-col md="4">
                    <b-button variant="primary"
                      @click="sinkronisasiDokumen(id_file_informasi_prl, 'file_informasi_prl')" class="text-white"
                      style="margin-right: 5px" size="sm"><i class="fa fa-repeat" /> Sinkronisasi Dokumen OSS</b-button>
                  </b-col>
                </template>
                <template v-else>
                  <b-col md="4">
                    <b-form-group>
                      <b-button variant="primary"
                        @click="sinkronisasiDokumen(id_file_informasi_prl, 'file_informasi_prl')" class="text-white"
                        style="margin-right: 5px" size="sm"><i class="fa fa-repeat" /> Sinkronisasi Dokumen
                        OSS</b-button>
                      <!-- <b-button
                      v-if="file_3 == null"
                      disabled
                      variant="primary"
                      @click="simpanPRL()"
                      class="text-white"
                      style="margin-right: 5px"
                      ><i class="fa fa-cloud-upload" /> Unggah</b-button
                    >
                    <b-button
                      v-else
                      variant="primary"
                      @click="simpanPRL()"
                      class="text-white"
                      style="margin-right: 5px"
                      ><i class="fa fa-cloud-upload" /> Unggah</b-button
                    > -->
                      <!-- <b-button variant="success" v-if="dataPermohonan.file_informasi_prl != null" class="text-white" style="margin-right:5px"><i class="fa fa-download"/> Download</b-button> -->
                      <b-button variant="success" v-if="dataPermohonan.file_informasi_prl == null" disabled
                        data-toggle="tooltip" data-placement="top" title="Tidak ada data" class="text-white"
                        style="margin-right: 5px" size="sm"><i class="fa fa-download" /> Download</b-button>
                      <a :href="dataPermohonan.file_informasi_prl" v-else type="button" class="btn btn-success btn-sm"
                        target="_blank" rel="noopener noreferrer"><i class="fa fa-download" /> Download</a>
                      <!-- <div class="form-check form-switch">
                                    <input class="form-check-input" type="checkbox" id="flexSwitchCheckDefault">
                                    <label class="form-check-label" for="flexSwitchCheckDefault">Sesuai</label>
                                </div> -->
                    </b-form-group>

                  </b-col>
                </template>
                <b-col md="8">
                  <div>Dokumen Informasi Pemanfaatan Ruang Laut</div>
                </b-col>

                <b-col md="3">
                  <!-- <b-form-group> -->
                  <div class="form-check form-switch">
                    <input v-model="dataPermohonan.verifikasi_informasi_prl"
                      @change="simpanIndikator('verifikasi_informasi_prl')" class="form-check-input" type="checkbox"
                      id="flexSwitchCheckDefault6" />
                    <label class="form-check-label" for="flexSwitchCheckDefault6">{{
                      dataPermohonan.verifikasi_informasi_prl
                        ? "Sesuai"
                        : "Tidak Sesuai"
                    }}</label>
                  </div>
                  <!-- </b-form-group> -->
                </b-col>
                <b-col md="1">
                  <b-button style="border-radius: 50px" variant="info" size="sm" title="Catatan"
                    v-b-modal.modal-keterangan @click="keterangan = dataPermohonan.verifikasi_informasi_prl_keterangan">
                    <i class="fa fa-file"></i>
                  </b-button>
                </b-col>
                <b-col md="12" class="divider-col">
                  <hr class="style1" md="12" />
                </b-col>
                <b-col md="5">
                  <div>
                    <p style="font-weight: 900; font-size: 17px">
                      Data kondisi terkini lokasi dan sekitarnya (ekosistem,
                      hidrografi, dan oseanografi)
                    </p>
                  </div>
                </b-col>
                <b-col md="3">
                  <b-form-group class="float-end">
                    <b-form-file ref="fileInput4" class="d-none" v-model="file_4" accept=".doc, .docx, .xlsx, .pdf"
                      @input="simpanKondisi"></b-form-file>

                    <b-button variant="secondary" @click="$refs.fileInput4.$el.querySelector('input').click()"
                      class="text-white" size="sm">
                      <i class="fa fa-upload"></i> Unggah File
                    </b-button>
                  </b-form-group>
                </b-col>
                <template v-if="dataPermohonan.file_data_kondisi_terkini == null">
                  <b-col md="4">
                    <b-button variant="primary"
                      @click="sinkronisasiDokumen(id_file_data_kondisi_terkini, 'file_data_kondisi_terkini')"
                      class="text-white" style="margin-right: 5px" size="sm"><i class="fa fa-repeat" /> Sinkronisasi
                      Dokumen OSS</b-button>
                  </b-col>
                </template>
                <template v-else>
                  <b-col md="4">
                    <b-button variant="primary"
                      @click="sinkronisasiDokumen(id_file_data_kondisi_terkini, 'file_data_kondisi_terkini')"
                      class="text-white" style="margin-right: 5px" size="sm"><i class="fa fa-repeat" /> Sinkronisasi
                      Dokumen OSS</b-button>
                    <!-- <b-button
                    v-if="file_4 == null"
                    disabled
                    variant="primary"
                    @click="simpanKondisi()"
                    class="text-white"
                    style="margin-right: 5px"
                    ><i class="fa fa-cloud-upload" /> Unggah</b-button
                  >
                  <b-button
                    v-else
                    variant="primary"
                    @click="simpanKondisi()"
                    class="text-white"
                    style="margin-right: 5px"
                    ><i class="fa fa-cloud-upload" /> Unggah</b-button
                  > -->
                    <!-- <b-button variant="success" v-if="dataPermohonan.file_data_kondisi_terkini != null" class="text-white" style="margin-right:5px"><i class="fa fa-download"/> Download</b-button> -->
                    <b-button variant="success" v-if="dataPermohonan.file_data_kondisi_terkini == null" disabled
                      data-toggle="tooltip" data-placement="top" title="Tidak ada data" class="text-white"
                      style="margin-right: 5px" size="sm"><i class="fa fa-download" /> Download</b-button>
                    <a :href="dataPermohonan.file_data_kondisi_terkini" v-else type="button"
                      class="btn btn-success btn-sm" target="_blank" rel="noopener noreferrer"><i
                        class="fa fa-download" /> Download</a>

                  </b-col>
                </template>
                <!-- <b-col md="12" class="divider-col">
                            <hr class="style1" md="12">
                        </b-col> -->
                <b-col md="12">
                  <div class="hr-sect">Ekosistem Sekitar</div>
                </b-col>
                <!-- <b-col md="3">
                        </b-col>
                        <b-col md="4">
                        </b-col> -->
                <!-- <b-col md="12" class="divider-col">
                            <hr class="style1" md="12">
                        </b-col> -->
                <b-col md="5">
                  <div>Mangrove</div>
                </b-col>
                <b-col md="3">
                  <!-- <b-form-group>
                                <b-form-file
                                placeholder="Choose a file or drop it here..."
                                drop-placeholder="Drop file here..."
                                plain
                                class="form-control"
                                ></b-form-file>
                            </b-form-group> -->
                </b-col>
                <b-col md="3">
                  <!-- <b-form-group> -->
                  <!-- <b-button variant="primary" class="text-white" style="margin-right:5px"><i class="fa fa-cloud-upload"/> Unggah</b-button>
                                <b-button variant="success" class="text-white" style="margin-right:5px"><i class="fa fa-download"/> Download</b-button> -->
                  <div class="form-check form-switch">
                    <input v-model="dataPermohonan.verifikasi_magrove" @change="simpanIndikator('verifikasi_magrove')"
                      class="form-check-input" type="checkbox" id="flexSwitchCheckDefault7" />
                    <label class="form-check-label" for="flexSwitchCheckDefault7">{{
                      dataPermohonan.verifikasi_magrove
                        ? "Sesuai"
                        : "Tidak Sesuai"
                    }}</label>
                  </div>
                  <!-- </b-form-group> -->
                </b-col>
                <b-col md="1">
                  <b-button style="border-radius: 50px" variant="info" size="sm" title="Catatan"
                    v-b-modal.modal-keterangan @click="keterangan = dataPermohonan.verifikasi_magrove_keterangan">
                    <i class="fa fa-file"></i>
                  </b-button>
                </b-col>
                <b-col md="12" class="divider-col">
                  <hr class="style1" md="12" />
                </b-col>
                <b-col md="5">
                  <div>Lamun</div>
                </b-col>
                <b-col md="3">
                  <!-- <b-form-group>
                                <b-form-file
                                placeholder="Choose a file or drop it here..."
                                drop-placeholder="Drop file here..."
                                plain
                                class="form-control"
                                ></b-form-file>
                            </b-form-group> -->
                </b-col>
                <b-col md="3">
                  <!-- <b-form-group> -->
                  <!-- <b-button variant="primary" class="text-white" style="margin-right:5px"><i class="fa fa-cloud-upload"/> Unggah</b-button>
                                <b-button variant="success" class="text-white" style="margin-right:5px"><i class="fa fa-download"/> Download</b-button> -->
                  <div class="form-check form-switch">
                    <input class="form-check-input" @change="simpanIndikator('verifikasi_lamun')"
                      v-model="dataPermohonan.verifikasi_lamun" type="checkbox" id="flexSwitchCheckDefault8" />
                    <label class="form-check-label" for="flexSwitchCheckDefault8">{{
                      dataPermohonan.verifikasi_lamun
                        ? "Sesuai"
                        : "Tidak Sesuai"
                    }}</label>
                  </div>
                  <!-- </b-form-group> -->
                </b-col>
                <b-col md="1">
                  <b-button style="border-radius: 50px" variant="info" size="sm" title="Catatan"
                    v-b-modal.modal-keterangan @click="keterangan = dataPermohonan.verifikasi_lamun_keterangan">
                    <i class="fa fa-file"></i>
                  </b-button>
                </b-col>
                <b-col md="12" class="divider-col">
                  <hr class="style1" md="12" />
                </b-col>
                <b-col md="8">
                  <div>Terumbu karang</div>
                </b-col>

                <b-col md="3">
                  <!-- <b-form-group> 
                                <b-button variant="primary" class="text-white" style="margin-right:5px"><i class="fa fa-cloud-upload"/> Unggah</b-button>
                                <b-button variant="success" class="text-white" style="margin-right:5px"><i class="fa fa-download"/> Download</b-button> -->
                  <div class="form-check form-switch">
                    <input class="form-check-input" @change="simpanIndikator('verifikasi_terumbu_karang')"
                      v-model="dataPermohonan.verifikasi_terumbu_karang" type="checkbox" id="flexSwitchCheckDefault9" />
                    <label class="form-check-label" for="flexSwitchCheckDefault9">{{
                      dataPermohonan.verifikasi_terumbu_karang
                        ? "Sesuai"
                        : "Tidak Sesuai"
                    }}</label>
                  </div>
                </b-col>
                <b-col md="1">
                  <b-button style="border-radius: 50px" variant="info" size="sm" title="Catatan"
                    v-b-modal.modal-keterangan
                    @click="keterangan = dataPermohonan.verifikasi_terumbu_karang_keterangan">
                    <i class="fa fa-file"></i>
                  </b-button>
                </b-col>

                <!-- <b-col md="12" class="divider-col">
                            <hr class="style1" md="12">
                        </b-col> -->
                <b-col md="12">
                  <div class="hr-sect">Hidro-oseanografi</div>
                </b-col>
                <!-- <b-col md="3">
                        
                        </b-col>
                        <b-col md="4">
                        
                        </b-col>
                        <b-col md="12" class="divider-col">
                            <hr class="style1" md="12">
                        </b-col> -->
                <b-col md="5">
                  <div>Arus</div>
                </b-col>
                <b-col md="3">
                  <!-- <b-form-group>
                                <b-form-file
                                placeholder="Choose a file or drop it here..."
                                drop-placeholder="Drop file here..."
                                plain
                                class="form-control"
                                ></b-form-file>
                            </b-form-group> -->
                </b-col>
                <b-col md="3">
                  <!-- <b-form-group> -->
                  <!-- <b-button variant="primary" class="text-white" style="margin-right:5px"><i class="fa fa-cloud-upload"/> Unggah</b-button>
                                <b-button variant="success" class="text-white" style="margin-right:5px"><i class="fa fa-download"/> Download</b-button> -->
                  <div class="form-check form-switch">
                    <input class="form-check-input" @change="simpanIndikator('verifikasi_arus')"
                      v-model="dataPermohonan.verifikasi_arus" type="checkbox" id="flexSwitchCheckDefault10" />
                    <label class="form-check-label" for="flexSwitchCheckDefault10">{{
                      dataPermohonan.verifikasi_arus
                        ? "Sesuai"
                        : "Tidak Sesuai"
                    }}</label>
                  </div>
                  <!-- </b-form-group> -->
                </b-col>
                <b-col md="1">
                  <b-button style="border-radius: 50px" variant="info" size="sm" title="Catatan"
                    v-b-modal.modal-keterangan @click="keterangan = dataPermohonan.verifikasi_arus_keterangan">
                    <i class="fa fa-file"></i>
                  </b-button>
                </b-col>
                <b-col md="12" class="divider-col">
                  <hr class="style1" md="12" />
                </b-col>
                <b-col md="5">
                  <div>Gelombang</div>
                </b-col>
                <b-col md="3">
                  <!-- <b-form-group>
                                <b-form-file
                                placeholder="Choose a file or drop it here..."
                                drop-placeholder="Drop file here..."
                                plain
                                class="form-control"
                                ></b-form-file>
                            </b-form-group> -->
                </b-col>
                <b-col md="3">
                  <!-- <b-form-group> -->
                  <!-- <b-button variant="primary" class="text-white" style="margin-right:5px"><i class="fa fa-cloud-upload"/> Unggah</b-button>
                                <b-button variant="success" class="text-white" style="margin-right:5px"><i class="fa fa-download"/> Download</b-button> -->
                  <div class="form-check form-switch">
                    <input class="form-check-input" @change="simpanIndikator('verifikasi_gelombang')"
                      v-model="dataPermohonan.verifikasi_gelombang" type="checkbox" id="flexSwitchCheckDefault11" />
                    <label class="form-check-label" for="flexSwitchCheckDefault11">{{
                      dataPermohonan.verifikasi_gelombang
                        ? "Sesuai"
                        : "Tidak Sesuai"
                    }}</label>
                  </div>
                  <!-- </b-form-group> -->
                </b-col>
                <b-col md="1">
                  <b-button style="border-radius: 50px" variant="info" size="sm" title="Catatan"
                    v-b-modal.modal-keterangan @click="keterangan = dataPermohonan.verifikasi_gelombang_keterangan">
                    <i class="fa fa-file"></i>
                  </b-button>
                </b-col>
                <b-col md="12" class="divider-col">
                  <hr class="style1" md="12" />
                </b-col>
                <b-col md="5">
                  <div>Pasang Surut</div>
                </b-col>
                <b-col md="3">
                  <!-- <b-form-group>
                                <b-form-file
                                placeholder="Choose a file or drop it here..."
                                drop-placeholder="Drop file here..."
                                plain
                                class="form-control"
                                ></b-form-file>
                            </b-form-group> -->
                </b-col>
                <b-col md="3">
                  <!-- <b-form-group> -->
                  <!-- <b-button variant="primary" class="text-white" style="margin-right:5px"><i class="fa fa-cloud-upload"/> Unggah</b-button>
                                <b-button variant="success" class="text-white" style="margin-right:5px"><i class="fa fa-download"/> Download</b-button> -->
                  <div class="form-check form-switch">
                    <input class="form-check-input" @change="simpanIndikator('verifikasi_pasang_surut')"
                      v-model="dataPermohonan.verifikasi_pasang_surut" type="checkbox" id="flexSwitchCheckDefault12" />
                    <label class="form-check-label" for="flexSwitchCheckDefault12">{{
                      dataPermohonan.verifikasi_pasang_surut
                        ? "Sesuai"
                        : "Tidak Sesuai"
                    }}</label>
                  </div>
                  <!-- </b-form-group> -->
                </b-col>
                <b-col md="1">
                  <b-button style="border-radius: 50px" variant="info" size="sm" title="Catatan"
                    v-b-modal.modal-keterangan @click="keterangan = dataPermohonan.verifikasi_pasang_surut_keterangan">
                    <i class="fa fa-file"></i>
                  </b-button>
                </b-col>
                <b-col md="12" class="divider-col">
                  <hr class="style1" md="12" />
                </b-col>
                <b-col md="5">
                  <div>Bathimetri</div>
                </b-col>
                <b-col md="3">
                  <!-- <b-form-group>
                                <b-form-file
                                placeholder="Choose a file or drop it here..."
                                drop-placeholder="Drop file here..."
                                plain
                                class="form-control"
                                ></b-form-file>
                            </b-form-group> -->
                </b-col>
                <b-col md="3">
                  <!-- <b-form-group> -->
                  <!-- <b-button variant="primary" class="text-white" style="margin-right:5px"><i class="fa fa-cloud-upload"/> Unggah</b-button>
                                <b-button variant="success" class="text-white" style="margin-right:5px"><i class="fa fa-download"/> Download</b-button> -->
                  <div class="form-check form-switch">
                    <input class="form-check-input" @change="simpanIndikator('verifikasi_bathimetri')"
                      v-model="dataPermohonan.verifikasi_bathimetri" type="checkbox" id="flexSwitchCheckDefault13" />
                    <label class="form-check-label" for="flexSwitchCheckDefault13">{{
                      dataPermohonan.verifikasi_bathimetri
                        ? "Sesuai"
                        : "Tidak Sesuai"
                    }}</label>
                  </div>
                  <!-- </b-form-group> -->
                </b-col>
                <b-col md="1">
                  <b-button style="border-radius: 50px" variant="info" size="sm" title="Catatan"
                    v-b-modal.modal-keterangan @click="keterangan = dataPermohonan.verifikasi_bathimetri_keterangan">
                    <i class="fa fa-file"></i>
                  </b-button>
                </b-col>
                <b-col md="12" class="divider-col">
                  <hr class="style1" md="12" />
                </b-col>
                <b-col md="5">
                  <p style="font-size: 15px">
                    Profil dasar laut disertai gambar
                  </p>
                </b-col>
                <b-col md="3">
                  <!-- <b-form-group>
                                <b-form-file
                                placeholder="Choose a file or drop it here..."
                                drop-placeholder="Drop file here..."
                                plain
                                class="form-control"
                                ></b-form-file>
                            </b-form-group> -->
                </b-col>
                <b-col md="3">
                  <!-- <b-form-group> -->
                  <!-- <b-button variant="primary" class="text-white" style="margin-right:5px"><i class="fa fa-cloud-upload"/> Unggah</b-button>
                                <b-button variant="success" class="text-white" style="margin-right:5px"><i class="fa fa-download"/> Download</b-button> -->
                  <div class="form-check form-switch">
                    <input class="form-check-input" @change="simpanIndikator('verifikasi_profil_dasar_laut')"
                      v-model="dataPermohonan.verifikasi_profil_dasar_laut" type="checkbox"
                      id="flexSwitchCheckDefault14" />
                    <label class="form-check-label" for="flexSwitchCheckDefault14">{{
                      dataPermohonan.verifikasi_profil_dasar_laut
                        ? "Sesuai"
                        : "Tidak Sesuai"
                    }}</label>
                  </div>
                  <!-- </b-form-group> -->
                </b-col>
                <b-col md="1">
                  <b-button style="border-radius: 50px" variant="info" size="sm" title="Catatan"
                    v-b-modal.modal-keterangan
                    @click="keterangan = dataPermohonan.verifikasi_profil_dasar_laut_keterangan">
                    <i class="fa fa-file"></i>
                  </b-button>
                </b-col>
                <b-col md="12" class="divider-col">
                  <hr class="style1" md="12" />
                </b-col>
                <b-col md="5">
                  <p style="font-size: 15px">
                    Kondisi/karakteristik sosial ekonomi masyarakat
                  </p>
                </b-col>
                <b-col md="3">
                  <!-- <b-form-group>
                                <b-form-file
                                placeholder="Choose a file or drop it here..."
                                drop-placeholder="Drop file here..."
                                plain
                                class="form-control"
                                ></b-form-file>
                            </b-form-group> -->
                </b-col>
                <b-col md="3">
                  <!-- <b-form-group> -->
                  <!-- <b-button variant="primary" class="text-white" style="margin-right:5px"><i class="fa fa-cloud-upload"/> Unggah</b-button>
                                <b-button variant="success" class="text-white" style="margin-right:5px"><i class="fa fa-download"/> Download</b-button> -->
                  <div class="form-check form-switch">
                    <input class="form-check-input" @change="
                      simpanIndikator('verifikasi_kondisi_sosial_ekonomi')
                      " v-model="dataPermohonan.verifikasi_kondisi_sosial_ekonomi" type="checkbox"
                      id="flexSwitchCheckDefault15" />
                    <label class="form-check-label" for="flexSwitchCheckDefault15">{{
                      dataPermohonan.verifikasi_kondisi_sosial_ekonomi
                        ? "Sesuai"
                        : "Tidak Sesuai"
                    }}</label>
                  </div>
                  <!-- </b-form-group> -->
                </b-col>
                <b-col md="1">
                  <b-button style="border-radius: 50px" variant="info" size="sm" title="Catatan"
                    v-b-modal.modal-keterangan
                    @click="keterangan = dataPermohonan.verifikasi_kondisi_sosial_ekonomi_keterangan">
                    <i class="fa fa-file"></i>
                  </b-button>
                </b-col>
                <b-col md="12" class="divider-col">
                  <hr class="style1" md="12" />
                </b-col>
                <b-col md="5">
                  <p style="font-size: 15px">
                    Aksesibilitas lokasi dan sekitar
                  </p>
                </b-col>
                <b-col md="3">
                  <!-- <b-form-group>
                                <b-form-file
                                placeholder="Choose a file or drop it here..."
                                drop-placeholder="Drop file here..."
                                plain
                                class="form-control"
                                ></b-form-file>
                            </b-form-group> -->
                </b-col>
                <b-col md="3">
                  <!-- <b-form-group> -->
                  <!-- <b-button variant="primary" class="text-white" style="margin-right:5px"><i class="fa fa-cloud-upload"/> Unggah</b-button>
                                <b-button variant="success" class="text-white" style="margin-right:5px"><i class="fa fa-download"/> Download</b-button> -->
                  <div class="form-check form-switch">
                    <input class="form-check-input" @change="
                      simpanIndikator('verifikasi_aksesibilitas_lokasi')
                      " v-model="dataPermohonan.verifikasi_aksesibilitas_lokasi" type="checkbox"
                      id="flexSwitchCheckDefault16" />
                    <label class="form-check-label" for="flexSwitchCheckDefault16">{{
                      dataPermohonan.verifikasi_aksesibilitas_lokasi
                        ? "Sesuai"
                        : "Tidak Sesuai"
                    }}</label>
                  </div>
                  <!-- </b-form-group> -->
                </b-col>
                <b-col md="1">
                  <b-button style="border-radius: 50px" variant="info" size="sm" title="Catatan"
                    v-b-modal.modal-keterangan
                    @click="keterangan = dataPermohonan.verifikasi_aksesibilitas_lokasi_keterangan">
                    <i class="fa fa-file"></i>
                  </b-button>
                </b-col>
                <b-col md="12" class="divider-col">
                  <hr class="style1" md="12" />
                </b-col>
                <b-col md="5">
                  <p style="font-weight: 900; font-size: 17px">
                    Persyaratan Lainnya
                  </p>
                </b-col>
                <b-col md="3">
                  <b-form-group class="float-end">
                    <b-form-file ref="fileInput5" class="d-none" v-model="file_5" accept=".doc, .docx, .xlsx, .pdf"
                      @input="simpanLain"></b-form-file>

                    <b-button variant="secondary" @click="$refs.fileInput5.$el.querySelector('input').click()"
                      class="text-white" size="sm">
                      <i class="fa fa-upload"></i> Unggah File
                    </b-button>
                  </b-form-group>
                </b-col>

                <template v-if="dataPermohonan.file_persyaratan_lain == null">
                  <b-col md="4">
                    <b-button variant="primary"
                      @click="sinkronisasiDokumen(id_file_persyaratan_lain, 'file_persyaratan_lain')" class="text-white"
                      style="margin-right: 5px" size="sm"><i class="fa fa-repeat" /> Sinkronisasi Dokumen OSS</b-button>
                  </b-col>
                </template>
                <template v-else>
                  <b-col md="4">
                    <b-form-group>
                      <b-button variant="primary"
                        @click="sinkronisasiDokumen(id_file_persyaratan_lain, 'file_persyaratan_lain')"
                        class="text-white" style="margin-right: 5px" size="sm"><i class="fa fa-repeat" /> Sinkronisasi
                        Dokumen OSS</b-button>
                      <!-- <b-button
                      v-if="file_5 == null"
                      disabled
                      variant="primary"
                      @click="simpanLain()"
                      class="text-white"
                      style="margin-right: 5px"
                      ><i class="fa fa-cloud-upload" /> Unggah</b-button
                    >
                    <b-button
                      v-else
                      variant="primary"
                      @click="simpanLain()"
                      class="text-white"
                      style="margin-right: 5px"
                      ><i class="fa fa-cloud-upload" /> Unggah</b-button
                    > -->
                      <!-- <b-button variant="success" v-if="dataPermohonan.file_persyaratan_lain" class="text-white" style="margin-right:5px"><i class="fa fa-download"/> Download</b-button> -->
                      <b-button variant="success" v-if="dataPermohonan.file_persyaratan_lain == null" disabled
                        data-toggle="tooltip" data-placement="top" title="Tidak ada data" class="text-white"
                        style="margin-right: 5px" size="sm"><i class="fa fa-download" /> Download</b-button>
                      <a :href="dataPermohonan.file_persyaratan_lain" v-else type="button"
                        class="btn btn-success btn-sm" target="_blank" rel="noopener noreferrer"><i
                          class="fa fa-download" /> Download</a>
                      <!-- <div class="form-check form-switch">
                                    <input class="form-check-input" type="checkbox" id="flexSwitchCheckDefault">
                                    <label class="form-check-label" for="flexSwitchCheckDefault">Sesuai</label>
                                </div> -->
                    </b-form-group>
                  </b-col>
                </template>

                <template v-if="dataPermohonan.file_persyaratan_lain != null">
                  <b-col md="8">
                    <div>Dokumen Persyratan Lainnya</div>
                  </b-col>

                  <b-col md="4">
                    <!-- <b-form-group> -->
                    <div class="form-check form-switch">
                      <input v-model="dataPermohonan.verifikasi_persyaratan_lain"
                        @change="simpanIndikator('verifikasi_persyaratan_lain')" class="form-check-input"
                        type="checkbox" id="flexSwitchCheckDefault6" />
                      <label class="form-check-label" for="flexSwitchCheckDefault6">{{
                        dataPermohonan.verifikasi_persyaratan_lain
                          ? "Sesuai"
                          : "Tidak Sesuai"
                      }}</label>
                    </div>
                    <!-- </b-form-group> -->
                  </b-col>
                </template>

                <template v-if="dataPermohonan.reklamasi == true">
                  <b-col md="12" class="divider-col">
                    <hr class="style1" md="12" />
                  </b-col>
                  <b-col md="5">
                    <p style="font-weight: 900; font-size: 17px">
                      Persyaratan Reklamasi
                    </p>
                  </b-col>
                  <b-col md="3">
                    <b-form-group class="float-end">
                      <b-form-file ref="fileInput6" class="d-none" v-model="file_6" accept=".doc, .docx, .xlsx, .pdf"
                        @input="simpanReklamasi"></b-form-file>

                      <b-button variant="secondary" @click="$refs.fileInput6.$el.querySelector('input').click()"
                        class="text-white" size="sm">
                        <i class="fa fa-upload"></i> Unggah File
                      </b-button>
                    </b-form-group>
                  </b-col>
                  <template v-if="dataPermohonan.file_persyaratan_reklamasi == null">
                    <b-col md="4">
                      <b-button variant="primary"
                        @click="sinkronisasiDokumen(id_file_persyaratan_reklamasi, 'file_persyaratan_reklamasi')"
                        class="text-white" style="margin-right: 5px" size="sm"><i class="fa fa-repeat" /> Sinkronisasi
                        Dokumen OSS</b-button>
                    </b-col>
                  </template>
                  <template v-else>
                    <b-col md="4">
                      <b-form-group>
                        <b-button variant="primary"
                          @click="sinkronisasiDokumen(id_file_persyaratan_reklamasi, 'file_persyaratan_reklamasi')"
                          class="text-white" style="margin-right: 5px" size="sm"><i class="fa fa-repeat" /> Sinkronisasi
                          Dokumen OSS</b-button>
                        <!-- <b-button
                        v-if="file_6 == null"
                        disabled
                        variant="primary"
                        @click="simpanReklamasi()"
                        class="text-white"
                        style="margin-right: 5px"
                        ><i class="fa fa-cloud-upload" /> Unggah</b-button
                      >
                      <b-button
                        v-else
                        variant="primary"
                        @click="simpanReklamasi()"
                        class="text-white"
                        style="margin-right: 5px"
                        ><i class="fa fa-cloud-upload" /> Unggah</b-button
                      > -->
                        <!-- <b-button variant="success" v-if="dataPermohonan.file_persyaratan_reklamasi != null" class="text-white" style="margin-right:5px"><i class="fa fa-download"/> Download</b-button> -->
                        <b-button variant="success" v-if="dataPermohonan.file_persyaratan_reklamasi == null" disabled
                          data-toggle="tooltip" data-placement="top" title="Tidak ada data" class="text-white"
                          style="margin-right: 5px" size="sm"><i class="fa fa-download" /> Download</b-button>
                        <a :href="dataPermohonan.file_persyaratan_reklamasi" v-else type="button"
                          class="btn btn-success btn-sm" target="_blank" rel="noopener noreferrer"><i
                            class="fa fa-download" />
                          Download</a>
                        <!-- <div class="form-check form-switch">
                                        <input class="form-check-input" type="checkbox" id="flexSwitchCheckDefault">
                                        <label class="form-check-label" for="flexSwitchCheckDefault">Sesuai</label>
                                    </div> -->
                      </b-form-group>
                    </b-col>
                  </template>
                  <b-col md="12" class="divider-col">
                    <hr class="style1" md="12" />
                  </b-col>
                  <b-col md="5">
                    <div>Rencana pengambilan sumber material reklamasi</div>
                  </b-col>
                  <b-col md="3">
                    <!-- <b-form-group>
                                    <b-form-file
                                    placeholder="Choose a file or drop it here..."
                                    drop-placeholder="Drop file here..."
                                    plain
                                    class="form-control"
                                    ></b-form-file>
                                </b-form-group> -->
                  </b-col>
                  <b-col md="4">
                    <!-- <b-form-group> -->
                    <!-- <b-button variant="primary" class="text-white" style="margin-right:5px"><i class="fa fa-cloud-upload"/> Unggah</b-button>
                                    <b-button variant="success" class="text-white" style="margin-right:5px"><i class="fa fa-download"/> Download</b-button> -->
                    <div class="form-check form-switch">
                      <input class="form-check-input" @change="
                        simpanIndikator(
                          'verifikasi_rencana_pengambilan_sumber_material'
                        )
                        " v-model="dataPermohonan.verifikasi_rencana_pengambilan_sumber_material
                          " type="checkbox" id="flexSwitchCheckDefault17" />
                      <label class="form-check-label" for="flexSwitchCheckDefault17">{{
                        dataPermohonan.verifikasi_rencana_pengambilan_sumber_material
                          ? "Sesuai"
                          : "Tidak Sesuai"
                      }}</label>
                    </div>
                    <!-- </b-form-group> -->
                  </b-col>
                  <b-col md="12" class="divider-col">
                    <hr class="style1" md="12" />
                  </b-col>
                  <b-col md="5">
                    <div>Rencana pemanfaatan lahan reklamasi</div>
                  </b-col>
                  <b-col md="3">
                    <!-- <b-form-group>
                                    <b-form-file
                                    placeholder="Choose a file or drop it here..."
                                    drop-placeholder="Drop file here..."
                                    plain
                                    class="form-control"
                                    ></b-form-file>
                                </b-form-group> -->
                  </b-col>
                  <b-col md="4">
                    <!-- <b-form-group> -->
                    <!-- <b-button variant="primary" class="text-white" style="margin-right:5px"><i class="fa fa-cloud-upload"/> Unggah</b-button>
                                    <b-button variant="success" class="text-white" style="margin-right:5px"><i class="fa fa-download"/> Download</b-button> -->
                    <div class="form-check form-switch">
                      <input class="form-check-input" @change="
                        simpanIndikator(
                          'verifikasi_rencana_pemanfaatan_lahan_reklamasi'
                        )
                        " v-model="dataPermohonan.verifikasi_rencana_pemanfaatan_lahan_reklamasi
                          " type="checkbox" id="flexSwitchCheckDefault18" />
                      <label class="form-check-label" for="flexSwitchCheckDefault18">{{
                        dataPermohonan.verifikasi_rencana_pemanfaatan_lahan_reklamasi
                          ? "Sesuai"
                          : "Tidak Sesuai"
                      }}</label>
                    </div>
                    <!-- </b-form-group> -->
                  </b-col>
                  <b-col md="12" class="divider-col">
                    <hr class="style1" md="12" />
                  </b-col>
                  <b-col md="5">
                    <div>Gambaran umum pelaksanaan reklamasi</div>
                  </b-col>
                  <b-col md="3">
                    <!-- <b-form-group>
                                    <b-form-file
                                    placeholder="Choose a file or drop it here..."
                                    drop-placeholder="Drop file here..."
                                    plain
                                    class="form-control"
                                    ></b-form-file>
                                </b-form-group> -->
                  </b-col>
                  <b-col md="4">
                    <!-- <b-form-group> -->
                    <!-- <b-button variant="primary" class="text-white" style="margin-right:5px"><i class="fa fa-cloud-upload"/> Unggah</b-button>
                                    <b-button variant="success" class="text-white" style="margin-right:5px"><i class="fa fa-download"/> Download</b-button> -->
                    <div class="form-check form-switch">
                      <input class="form-check-input" @change="
                        simpanIndikator('verifikasi_gambaran_umum_reklamasi')
                        " v-model="dataPermohonan.verifikasi_gambaran_umum_reklamasi
                          " type="checkbox" id="flexSwitchCheckDefault19" />
                      <label class="form-check-label" for="flexSwitchCheckDefault19">{{
                        dataPermohonan.verifikasi_gambaran_umum_reklamasi
                          ? "Sesuai"
                          : "Tidak Sesuai"
                      }}</label>
                    </div>
                    <!-- </b-form-group> -->
                  </b-col>
                  <b-col md="12" class="divider-col">
                    <hr class="style1" md="12" />
                  </b-col>
                  <b-col md="5">
                    <div>Jadwal rencana pelaksanaan reklamasi</div>
                  </b-col>
                  <b-col md="3">
                    <!-- <b-form-group>
                                    <b-form-file
                                    placeholder="Choose a file or drop it here..."
                                    drop-placeholder="Drop file here..."
                                    plain
                                    class="form-control"
                                    ></b-form-file>
                                </b-form-group> -->
                  </b-col>
                  <b-col md="4">
                    <!-- <b-form-group> -->
                    <!-- <b-button variant="primary" class="text-white" style="margin-right:5px"><i class="fa fa-cloud-upload"/> Unggah</b-button>
                                    <b-button variant="success" class="text-white" style="margin-right:5px"><i class="fa fa-download"/> Download</b-button> -->
                    <div class="form-check form-switch">
                      <input class="form-check-input" @change="
                        simpanIndikator('verifikasi_jadwal_rencana_reklamasi')
                        " v-model="dataPermohonan.verifikasi_jadwal_rencana_reklamasi
                          " type="checkbox" id="flexSwitchCheckDefault20" />
                      <label class="form-check-label" for="flexSwitchCheckDefault20">{{
                        dataPermohonan.verifikasi_jadwal_rencana_reklamasi
                          ? "Sesuai"
                          : "Tidak Sesuai"
                      }}</label>
                    </div>
                    <!-- </b-form-group> -->
                  </b-col>
                  <b-col md="12" class="divider-col">
                    <hr class="style1" md="12" />
                  </b-col>
                </template>
              </b-row>

              <!-- v-if="
                dataPermohonan.verifikasi_dokumen_dasar === true &&
                dataPermohonan.verifikasi_kegiatan_eksisting === true &&
                dataPermohonan.verifikasi_rencana_jadwal === true &&
                dataPermohonan.verifikasi_rencana_site_plan === true &&
                dataPermohonan.verifikasi_deskriptif_luasan === true &&
                dataPermohonan.verifikasi_peta_lokasi === true &&
                dataPermohonan.verifikasi_magrove === true &&
                dataPermohonan.verifikasi_lamun === true &&
                dataPermohonan.verifikasi_terumbu_karang === true &&
                dataPermohonan.verifikasi_arus === true &&
                dataPermohonan.verifikasi_gelombang === true &&
                dataPermohonan.verifikasi_pasang_surut === true &&
                dataPermohonan.verifikasi_bathimetri === true &&
                dataPermohonan.verifikasi_profil_dasar_laut === true &&
                dataPermohonan.verifikasi_kondisi_sosial_ekonomi === true &&
                dataPermohonan.verifikasi_aksesibilitas_lokasi === true
              " -->
              <form ref="form" @submit.stop.prevent="tambahdata" data-vv-scope="form-2">
              <b-row>
                <hr class="mt-3">
                <b-col md="6" class="mt-2">
                  <b-form-group label="Pilih Admin Penjadwalan Pentek *">
                    <v-select id="default-select"
                      :options="dataUser" :reduce="(user) => user.id" label="nama" v-model="dataPermohonan.id_admin"
                      v-validate="'required'" name="Pilih Admin" :class="{
                        'is-invalid': errors.has('form-2.Pilih Admin'),
                      }" />
                    
                    <span class="text-danger" v-if="errors.has('form-2.Pilih Admin')">
                      {{ errors.first("form-2.Pilih Admin") }}
                    </span>
                  </b-form-group>
                </b-col>
              </b-row>
              </form>

              <!-- v-if="
                dataPermohonan.verifikasi_dokumen_dasar != true ||
                dataPermohonan.verifikasi_kegiatan_eksisting != true ||
                dataPermohonan.verifikasi_rencana_jadwal != true ||
                dataPermohonan.verifikasi_rencana_site_plan != true ||
                dataPermohonan.verifikasi_deskriptif_luasan != true ||
                dataPermohonan.verifikasi_peta_lokasi != true ||
                dataPermohonan.verifikasi_magrove != true ||
                dataPermohonan.verifikasi_lamun != true ||
                dataPermohonan.verifikasi_terumbu_karang != true ||
                dataPermohonan.verifikasi_arus != true ||
                dataPermohonan.verifikasi_gelombang != true ||
                dataPermohonan.verifikasi_pasang_surut != true ||
                dataPermohonan.verifikasi_bathimetri != true ||
                dataPermohonan.verifikasi_profil_dasar_laut != true ||
                dataPermohonan.verifikasi_kondisi_sosial_ekonomi != true ||
                dataPermohonan.verifikasi_aksesibilitas_lokasi != true
              " -->
              <div class="row">
                <b-col md="12">
                  <div class="form-group mt-2">
                    <b-form-group label="Catatan: *">
                      <div class="mb-3">
                        <span class="small text-muted text-danger">Berikan catatan untuk penolakan atau perbaikan
                          persyaratan </span>
                      </div>

                      <ckeditor v-model="dataPermohonan.catatan_verdok" :editor="wygEditor"></ckeditor>
                    </b-form-group>
                  </div>
                </b-col>
              </div>


            </b-form>
            <div class="row justify-content-between">
              <div class="col-6">
                <div class="text-left">
                  <b-button @click="previousDokumen()" variant="primary"><i class="fa fa-caret-left" />
                    Sebelumnya</b-button>
                </div>
              </div>
              <div class="col-6">
                <div class="text-right">
                  <!-- <b-button v-b-modal.modal-final-ba class="mr-1" variant="outline-info"><i class="fa fa-file" />
                    Generate BA
                    Verifikasi
                    Administrasi</b-button> -->

                  <b-button @click="fiinishDokumen()" style="float: right" variant="success">Selesai <i
                      class="fa fa-check" /></b-button>
                </div>
              </div>
            </div>
          </tab-content>
          <!-- <tab-content title="3. Jadwal">
                <b-form>
                    <b-row >
                        <b-col md="6">
                            <b-form-group label="Pilih PIC: *" label-for="username">
                                <v-select
                                        id="default-select"
                                        v-model="defaultSelect"
                                        :options="['Large Magellanic Cloud', 'Andromeda Galaxy', 'SextansA']"
                                    />
                            </b-form-group>
                        </b-col>
                        <b-col md="6">
                            <b-form-group label="Jadwal Penilaian Teknis *" label-for="username">
                                <input type="date" class="form-control" />
                            </b-form-group>
                        </b-col>
                    </b-row>
                </b-form>
                <div class="row justify-content-between">
                <div class="col-4">
                    <div class="text-left">
                        <b-button @click="previousPelaku()" variant="primary" ><i class="fa fa-caret-left" /> Sebelumnya</b-button>
                    </div>
                </div>
                <div class="col-4">
                    <div class="text-right">
                        <b-button @click="finishPelaku()" style="float:right" variant="success" >Selesai <i class="fa fa-check" /></b-button>
                    </div>
                </div>
              </div>
              </tab-content> -->
        </form-wizard>
      </Widget>
    </b-col>

    <b-modal body-class="bg-white" id="modal-final-ba" title="TANDA TERIMA/BERITA ACARA VERIFIKASI ADMINISTRASI"
      cancel-title="Close" ok-title="Accept" size="md" cancel-variant="outline-secondary">
      <form ref="form" @submit.stop.prevent="tambahdata" data-vv-scope="form-1">
        <b-row>
          <b-col md="12">
            <b-form-group label="Nomor Berita Acara: *" label-for="No Berita Acara">
              <input :class="{ 'form-control': true }" type="txt" v-validate="'required'" name="Nomor Berita Acara"
                v-model="nomorBA" />
            </b-form-group>
          </b-col>
          <!-- PIC Verdok -->
          <b-col md="12" class="mt-2">
            <b-form-group label="PIC Verdok *" label-for="PIC Verdok">
              <v-select id="default-select" :options="dataUserPICVerdok" :reduce="(user) => user.id" label="nama"
                v-model="dataPermohonan.id_pic_verdok" v-validate="'required'" name="PIC Verdok" :class="{
                  'is-invalid': errors.has('form-1.PIC Verdok'),
                }" />
              <span class="text-danger" v-if="errors.has('form-1.PIC Verdok')">
                {{ errors.first("form-1.PIC Verdok") }}
              </span>
            </b-form-group>
          </b-col>
        </b-row>

      </form>

      <template #modal-footer>
        <div class="w-100">
          <b-button variant="primary" style="float: right" @click="verifikasiDokumen()">
            <i class="fa fa-floppy-o text-white" />

            <span class="text-white"> Simpan</span>
          </b-button>
        </div>
      </template>
    </b-modal>

    <b-modal ok-only ok-title="Tutup" id="modal-keterangan" title="Keterangan Status Kesesuaian">
      {{ keterangan }}
    </b-modal>
  </b-row>
</template>

<script>
import Vue from "vue";
import vSelect from "vue-select";
import Widget from "@/components/Widget/Widget";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import axios from "axios";
import moment from "moment";
import { temperature } from "chroma-js";
import Swal from "sweetalert2";
import Profil from "../Detail/Profil/Profil.vue";
import toast from "../../../../helper/toast";

//   import { select2CountriesData, select2ShipmentData, cardTypesData } from './data';

export default {
  name: "FormWizardPage",
  components: { Widget, vSelect, ClassicEditor, Profil },
  data() {
    return {
      baseapi: localStorage.getItem("baseapi"),
      user: JSON.parse(localStorage.getItem("user")),
      baseapiMetra: localStorage.getItem("baseapiMetra"),
      apiKey: localStorage.getItem("api-key"),
      progress: 1,
      dataJenisProyek: [],
      dataRisiko: [],
      dataSkalaUsaha: [],
      dataStatusVerdok: [],
      dataPerDokumen: [],
      dataPermohonan: {},
      dataUser: [],
      file_1: null,
      file_2: null,
      file_3: null,
      file_4: null,
      file_5: null,
      file_6: null,
      wygEditor: ClassicEditor,
      optionsPrioritas: [
        { value: true, text: "Ya" },
        { value: false, text: "Tidak" },
      ],
      dataReklamasi: [
        { value: true, text: "Ya" },
        { value: false, text: "Tidak" },
      ],
      optionsKategori: [
        { value: 'Permohonan Baru', text: "Permohonan Baru" },
        { value: 'Penambahan KBLI', text: "Penambahan KBLI" },
        { value: 'Notifikasi Izin Lokasi', text: "Notifikasi Izin Lokasi" },
      ],
      optionsTipe: [
        { value: 'Single KBLI', text: "Single KBLI" },
        { value: 'Multi KBLI', text: "Multi KBLI" },
      ],

      optionsMultiKBLI: [
        { value: 'Proses', text: "Proses" },
        { value: 'Pengikut', text: "Pengikut" },
      ],
      dataKBLI: [],
      dataKlasifikasi: [],
      nomorBA: null,
      konfirmasi: null,
      keterangan: null,
      id_file_rencana_bangunan_dan_instalasi_di_laut: null,
      id_file_informasi_prl: null,
      id_file_persyaratan_lain: null,
      id_file_data_kondisi_terkini: null,
      id_file_kordinat: null,
      id_file_persyaratan_reklamasi: null,
      dataUserPICVerdok: [],
      statusVerdok: null
    };
  },
  mounted() {
    this.getRisiko();
    this.getJenisProyek();
    this.getSkalaUsaha();
    this.getStatusVerdok();
    this.getUser();
    this.getKBLI();
    this.loaddatafirst();
    this.getKlasifikasi();
    this.getDataUserPIC()
  },
  methods: {
    updateProgress(prevIndex, nextIndex) {
      if (nextIndex >= 0) {
        Vue.set(this, "progress", nextIndex + 1);
      }
    },

    getJenisProyek() {
      axios
        .get(this.baseapi + "api/jenis_proyek", {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((response) => {
          this.dataJenisProyek = response.data.data;
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    },
    getKBLI() {
      axios
        .get(this.baseapi + "api/kbli", {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((response) => {
          this.dataKBLI = response.data.data;
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    },

    //get Klasifikasi

    getKlasifikasi() {
      axios
        .get(this.baseapi + "api/klasifikasi_pemohon", {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((response) => {
          this.dataKlasifikasi = response.data.data;
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    },

    getUser() {
      axios
        .get(this.baseapi + "api/user?filter=role,=,admin_kkp", {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((response) => {
          let data = [];
          data = response.data.data;

          for (let index = 0; index < data.length; index++) {
            if (data[index].role === "admin_kkp") {
              this.dataUser.push({
                nama: data[index].nama + "-" + data[index].nama_provinsi,
                id: data[index].id,
              });
            } else if (data[index].role === "admin_upt") {
              this.dataUser.push({
                nama: data[index].nama + "-" + data[index].nama_provinsi,
                id: data[index].id,
              });
            } else {
              continue;
            }
          }
          console.log(this.dataUser);
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    },

    simpanProfil() {
      document.getElementById("next").click();
    },

    previousDokumen() {
      document.getElementById("back").click();
    },

    fiinishDokumen() {
      
          Swal.fire({
            title: "Konfirmasi",
            text: "Silahkan verifikasi dokumen?",
            icon: "question",
            showCancelButton: true,
            showDenyButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#8C9AA2",
            denyButtonColor: "#d33",
            confirmButtonText: "Dokumen Lengkap",
            denyButtonText: "Perbaikan Persyaratan"
          }).then((result) => {
            if (result.isDenied) {
              if ((this.dataPermohonan.verifikasi_dokumen_dasar != true ||
                this.dataPermohonan.verifikasi_kegiatan_eksisting != true ||
                this.dataPermohonan.verifikasi_rencana_jadwal != true ||
                this.dataPermohonan.verifikasi_rencana_site_plan != true ||
                this.dataPermohonan.verifikasi_deskriptif_luasan != true ||
                this.dataPermohonan.verifikasi_peta_lokasi != true ||
                this.dataPermohonan.verifikasi_magrove != true ||
                this.dataPermohonan.verifikasi_lamun != true ||
                this.dataPermohonan.verifikasi_terumbu_karang != true ||
                this.dataPermohonan.verifikasi_arus != true ||
                this.dataPermohonan.verifikasi_gelombang != true ||
                this.dataPermohonan.verifikasi_pasang_surut != true ||
                this.dataPermohonan.verifikasi_bathimetri != true ||
                this.dataPermohonan.verifikasi_profil_dasar_laut != true ||
                this.dataPermohonan.verifikasi_kondisi_sosial_ekonomi != true ||
                this.dataPermohonan.verifikasi_aksesibilitas_lokasi != true) && (this.dataPermohonan.catatan_verdok == null || this.dataPermohonan.catatan_verdok == '')) {
                Swal.fire({
                  icon: "error",
                  title: "Gagal",
                  text: "Masukkan catatan terlebih dahulu",
                });
              } else {
                if (this.dataPermohonan.verifikasi_dokumen_dasar != true ||
                  this.dataPermohonan.verifikasi_kegiatan_eksisting != true ||
                  this.dataPermohonan.verifikasi_rencana_jadwal != true ||
                  this.dataPermohonan.verifikasi_rencana_site_plan != true ||
                  this.dataPermohonan.verifikasi_deskriptif_luasan != true ||
                  this.dataPermohonan.verifikasi_peta_lokasi != true ||
                  this.dataPermohonan.verifikasi_magrove != true ||
                  this.dataPermohonan.verifikasi_lamun != true ||
                  this.dataPermohonan.verifikasi_terumbu_karang != true ||
                  this.dataPermohonan.verifikasi_arus != true ||
                  this.dataPermohonan.verifikasi_gelombang != true ||
                  this.dataPermohonan.verifikasi_pasang_surut != true ||
                  this.dataPermohonan.verifikasi_bathimetri != true ||
                  this.dataPermohonan.verifikasi_profil_dasar_laut != true ||
                  this.dataPermohonan.verifikasi_kondisi_sosial_ekonomi != true ||
                  this.dataPermohonan.verifikasi_aksesibilitas_lokasi != true) {
                  this.dataPermohonan.id_admin = null
                } else {
                  this.dataPermohonan.catatan_verdok = null

                }

                this.statusVerdok = 'Perbaikan Persyaratan'
                this.$bvModal.show('modal-final-ba')
              }

            } else if (result.isConfirmed) {
              this.$validator.validateAll("form-2").then((result) => {
              if (result) {
                if((this.dataPermohonan.verifikasi_dokumen_dasar != true ||
                this.dataPermohonan.verifikasi_kegiatan_eksisting != true ||
                this.dataPermohonan.verifikasi_rencana_jadwal != true ||
                this.dataPermohonan.verifikasi_rencana_site_plan != true ||
                this.dataPermohonan.verifikasi_deskriptif_luasan != true ||
                this.dataPermohonan.verifikasi_peta_lokasi != true ||
                this.dataPermohonan.verifikasi_magrove != true ||
                this.dataPermohonan.verifikasi_lamun != true ||
                this.dataPermohonan.verifikasi_terumbu_karang != true ||
                this.dataPermohonan.verifikasi_arus != true ||
                this.dataPermohonan.verifikasi_gelombang != true ||
                this.dataPermohonan.verifikasi_pasang_surut != true ||
                this.dataPermohonan.verifikasi_bathimetri != true ||
                this.dataPermohonan.verifikasi_profil_dasar_laut != true ||
                this.dataPermohonan.verifikasi_kondisi_sosial_ekonomi != true ||
                this.dataPermohonan.verifikasi_aksesibilitas_lokasi != true) && (this.dataPermohonan.kategori_permohonan != 'Notifikasi Izin Lokasi' && this.dataPermohonan.kategori_permohonan != 'Penambahan KBLI')) {
                  Swal.fire({
                    icon: "error",
                    title: "Gagal",
                    text: "Semua indikator harus sesuai untuk dokumen lengkap"+ this.dataPermohonan.kategori_permohonan,
                  });
                  return
                }else{
                  this.statusVerdok = 'Dokumen Lengkap'
                  this.$bvModal.show('modal-final-ba')
                }
              } else {
                toast.error(this,"Pilih admin penjadwalan pentek");
              }
            })
              
              
            }
          });




    },

    verifikasiDokumen() {
      this.$loading(true);
      axios
        .post(
          this.baseapi + "api/notifikasi_izin_lokasi/uploadDokumen/" + this.$route.params.id,
          {
            tanggal_proses: moment(Date.now()).format("YYYY-MM-DD"),
            id_admin: this.dataPermohonan.id_admin,
            catatan_verdok: this.dataPermohonan.catatan_verdok,
          },
          {
            headers: {
              Authorization: `Bearer ` + this.user.accessToken,
            },
          }
        )
        .then((res) => {
          this.$loading(false);
          this.finalBA()
          return res;
        })
        .catch((err) => {
          this.$loading(false);
          console.log(err);
          this.$toasted.error(err.response.data.message);
          // document.getElementById("finish").click();
          return err;
        });
    },

    simpanIndikator(value) {
      console.log(this.$route.params.id);
      // let value = 'verifikasi_dokumen_dasar'
      let data = {};
      data[value] = this.dataPermohonan[value];
      // let data = {
      //         verifikasi_dokumen_dasar: this.dataPermohonan.verifikasi_dokumen_dasar,
      //         verifikasi_kegiatan_eksisting: this.dataPermohonan.verifikasi_kegiatan_eksisting,
      //         verifikasi_rencana_jadwal: this.dataPermohonan.verifikasi_rencana_jadwal,
      //         verifikasi_rencana_site_plan: this.dataPermohonan.verifikasi_rencana_site_plan,
      //         verifikasi_deskriptif_luasan: this.dataPermohonan.verifikasi_deskriptif_luasan,
      //         verifikasi_peta_lokasi: this.dataPermohonan.verifikasi_peta_lokasi,

      //         verifikasi_magrove: this.dataPermohonan.verifikasi_magrove,
      //         verifikasi_lamun: this.dataPermohonan.verifikasi_lamun,
      //         verifikasi_terumbu_karang: this.dataPermohonan.verifikasi_terumbu_karang,
      //         verifikasi_arus: this.dataPermohonan.verifikasi_arus,
      //         verifikasi_gelombang: this.dataPermohonan.verifikasi_gelombang,
      //         verifikasi_pasang_surut: this.dataPermohonan.verifikasi_pasang_surut,
      //         verifikasi_bathimetri: this.dataPermohonan.verifikasi_bathimetri,
      //         verifikasi_profil_dasar_laut: this.dataPermohonan.verifikasi_profil_dasar_laut,
      //         verifikasi_kondisi_sosial_ekonomi: this.dataPermohonan.verifikasi_kondisi_sosial_ekonomi,
      //         verifikasi_aksesibilitas_lokasi: this.dataPermohonan.verifikasi_aksesibilitas_lokasi,

      //         verifikasi_rencana_pengambilan_sumber_material: this.dataPermohonan.verifikasi_rencana_pengambilan_sumber_material,
      //         verifikasi_rencana_pemanfaatan_lahan_reklamasi: this.dataPermohonan.verifikasi_rencana_pemanfaatan_lahan_reklamasi,
      //         verifikasi_gambaran_umum_reklamasi: this.dataPermohonan.verifikasi_gambaran_umum_reklamasi,
      //         verifikasi_jadwal_rencana_reklamasi: this.dataPermohonan.verifikasi_jadwal_rencana_reklamasi
      // }
      axios
        .post(
          this.baseapi + "api/notifikasi_izin_lokasi/" + this.$route.params.id,

          data,

          {
            headers: {
              Authorization: `Bearer ` + this.user.accessToken,
            },
          }
        )
        .then((res) => {
          // this.$toasted.success("Berhasil Diubah");
          // document.getElementById("finish").click();
          return res;
        })
        .catch((err) => {
          console.log(err);
          this.$toasted.error(err.response.data.message);
          // document.getElementById("finish").click();
          return err;
        });
    },

    getRisiko() {
      axios
        .get(this.baseapi + "api/risiko", {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((response) => {
          this.dataRisiko = response.data.data;
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    },

    getSkalaUsaha() {
      axios
        .get(this.baseapi + "api/skala_usaha", {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((response) => {
          this.dataSkalaUsaha = response.data.data;
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    },

    simpanKordinat() {
      if (!this.file_1) return;
      this.$loading(true);
      let formData = new FormData();
      formData.append("file_kordinat", this.file_1);
      // tampak_depan
      axios
        .post(
          this.baseapi + "api/notifikasi_izin_lokasi/uploadDokumen/" + this.$route.params.id,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ` + this.user.accessToken,
            },
          }
        )
        .then((response) => {
          this.$loading(false);
          this.$toasted.success("Berhasil Diunggah");
          this.loaddata();
          return response;
        })
        .catch((error) => {
          this.$loading(false);
          this.$toasted.danger("Gagal Diunggah");
          return error;
        });
    },

    simpanBangunan() {
      if (!this.file_2) return;
      this.$loading(true);
      let formData = new FormData();
      formData.append(
        "file_rencana_bangunan_dan_instalasi_di_laut",
        this.file_2,
        "rencana_bangunan_dan_instalasi_di_laut.pdf"
      );
      // tampak_depan
      axios
        .post(
          this.baseapi + "api/notifikasi_izin_lokasi/uploadDokumen/" + this.$route.params.id,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ` + this.user.accessToken,
            },
          }
        )
        .then((response) => {
          this.$loading(false);
          this.$toasted.success("Berhasil Diunggah");
          this.loaddata();
          return response;
        })
        .catch((error) => {
          this.$loading(false);
          this.$toasted.danger("Gagal Diunggah");
          return error;
        });
    },

    simpanPRL() {
      if (!this.file_3) return;
      this.$loading(true);
      let formData = new FormData();
      formData.append("file_informasi_prl", this.file_3,"informasi_prl.pdf");
      // tampak_depan
      axios
        .post(
          this.baseapi + "api/notifikasi_izin_lokasi/uploadDokumen/" + this.$route.params.id,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ` + this.user.accessToken,
            },
          }
        )
        .then((response) => {
          this.$loading(false);
          this.$toasted.success("Berhasil Diunggah");
          this.loaddata();
          return response;
        })
        .catch((error) => {
          this.$loading(false);
          this.$toasted.danger("Gagal Diunggah");
          return error;
        });
    },

    simpanKondisi() {
      if (!this.file_4) return;
      this.$loading(true);
      let formData = new FormData();
      formData.append("file_data_kondisi_terkini", this.file_4,"data_kondisi_terkini.pdf");
      // tampak_depan
      axios
        .post(
          this.baseapi + "api/notifikasi_izin_lokasi/uploadDokumen/" + this.$route.params.id,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ` + this.user.accessToken,
            },
          }
        )
        .then((response) => {
          this.$loading(false);
          this.$toasted.success("Berhasil Diunggah");
          this.loaddata();
          return response;
        })
        .catch((error) => {
          this.$loading(false);
          this.$toasted.danger("Gagal Diunggah");
          return error;
        });
    },

    simpanLain() {
      if (!this.file_5) return;
      this.$loading(true);
      let formData = new FormData();
      formData.append("file_persyaratan_lain", this.file_5,"persyaratan_lain.pdf");
      // tampak_depan
      axios
        .post(
          this.baseapi + "api/notifikasi_izin_lokasi/uploadDokumen/" + this.$route.params.id,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ` + this.user.accessToken,
            },
          }
        )
        .then((response) => {
          this.$loading(false);
          this.$toasted.success("Berhasil Diunggah");
          this.loaddata();
          return response;
        })
        .catch((error) => {
          this.$loading(false);
          this.$toasted.danger("Gagal Diunggah");
          return error;
        });
    },

    simpanReklamasi() {
      if (!this.file_6) return;
      this.$loading(true);
      let formData = new FormData();
      formData.append("file_persyaratan_reklamasi", this.file_6,"persyaratan_reklamasi.pdf");
      // tampak_depan
      axios
        .post(
          this.baseapi + "api/notifikasi_izin_lokasi/uploadDokumen/" + this.$route.params.id,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ` + this.user.accessToken,
            },
          }
        )
        .then((response) => {
          this.$loading(false);
          this.$toasted.success("Berhasil Diunggah");
          this.loaddata();
          return response;
        })
        .catch((error) => {
          this.$loading(false);
          this.$toasted.danger("Gagal Diunggah");
          return error;
        });
    },

    loaddata() {
      axios
        .get(this.baseapi + "api/notifikasi_izin_lokasi/" + this.$route.params.id, {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((response) => {
          this.file_1 = null
          this.file_2 = null
          this.file_3 = null
          this.file_4 = null
          this.file_5 = null
          this.file_6 = null
          this.dataPermohonan = response.data.data;


        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    },

    loaddatafirst() {
      axios
        .get(this.baseapi + "api/notifikasi_izin_lokasi/" + this.$route.params.id, {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((response) => {
          this.file_1 = null
          this.file_2 = null
          this.file_3 = null
          this.file_4 = null
          this.file_5 = null
          this.file_6 = null
          this.dataPermohonan = response.data.data;
          this.getDataDokumen()
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    },

    getStatusVerdok() {
      axios
        .get(this.baseapi + "api/status_verdok", {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((response) => {
          this.dataStatusVerdok = response.data.data;
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    },

    getDataUserPIC() {
      let apiPIC;
      apiPIC = "api/user?filter=role,=,admin_kkp";
      axios
        .get(this.baseapi + apiPIC, {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((response) => {
          this.dataUserPICVerdok = response.data.data;
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    },

    finalBA() {
      this.$validator.validateAll("form-1").then((result) => {
        if (result) {
          this.$nextTick(() => {
            this.$bvModal.hide("modal-final-ba");
          });
          this.$loading(true);
          axios
            .put(
              this.baseapi + "api/notifikasi_izin_lokasi/generateBAVerdok/" + this.$route.params.id,
              {
                nomor_ba_verdok: this.nomorBA,
                status_verdok: this.statusVerdok,
                id_pic_verdok: this.dataPermohonan.id_pic_verdok
              },
              {
                headers: {
                  "Content-type": "application/json",
                  Authorization: `Bearer ` + this.user.accessToken,
                },
              }
            )
            .then((res) => {
              this.$loading(false);
              this.$toasted.success("Berhasil melakukan Verifikasi Dokumen");
              document.getElementById("finish").click();

              return res;
            })
            .catch((err) => {
              this.$loading(false);
              console.log(err);
              this.$toasted.error(err.response.data.message);
              return err;
            });
        }
      });
    },


    //Get id Dokumen masing-masing
    getDataDokumen() {
      this.$loading(true);
      var resultFilter

      if (this.dataPermohonan.nib_pemohon != null) {
        resultFilter = 'nib=' + this.dataPermohonan.nib_pemohon
      } else {
        resultFilter = 'npwp=' + this.dataPermohonan.npwp_pemohon
      }

      axios.get(`${this.baseapi}api/sync/syncOSS?method=inqueryPKKPRL&nib=${this.dataPermohonan.nib_pemohon}&nomor_permohonan=${this.dataPermohonan.nomor_permohonan}`,
        {
          headers: {
            Authorization: `Bearer ${this.user.accessToken}`,
          }
        }
      )
        .then((res) => {
          const responsdata = res.data.data
          console.log(responsdata)
          this.id_file_kordinat = responsdata.data.id_file_kordinat
          this.id_file_rencana_bangunan_dan_instalasi_di_laut = responsdata.data.id_file_rencana_bangunan_dan_instalasi_di_laut
          this.id_file_informasi_prl = responsdata.data.id_file_informasi_prl
          this.id_file_data_kondisi_terkini = responsdata.data.id_file_data_kondisi_terkini
          this.id_file_persyaratan_lain = responsdata.data.id_file_persyaratan_lain
          this.id_file_persyaratan_reklamasi = responsdata.data.id_file_persyaratan_reklamasi

          this.$loading(false);
        }).catch((e) => {
          this.$loading(false);
        })
    },

    //Sinkronisasi Dokumen
    sinkronisasiDokumen(idfile, jenis) {
      if(idfile == null){
        this.$toasted.error("Tidak ada file dari OSS");
        return
      }
      this.$loading(true);

      axios.get(`${this.baseapi}api/sync/syncOSS?method=printFileDS&id_file=${idfile}`, {
        responseType: 'blob',
        headers: {
          Authorization: `Bearer ${this.user.accessToken}`,
        }
      })
        .then((res) => {
          const blob = new Blob([res.data], { type: res.headers['content-type'] || 'application/pdf' });

          if (jenis === 'file_kordinat') {
            this.file_1 = blob;
            this.simpanKordinat();
          } else if (jenis === 'file_rencana_bangunan_dan_instalasi_di_laut') {
            this.file_2 = blob;
            this.simpanBangunan();
          } else if (jenis === 'file_informasi_prl') {
            this.file_3 = blob;
            this.simpanPRL();
          } else if (jenis === 'file_data_kondisi_terkini') {
            this.file_4 = blob;
            this.simpanKondisi();
          } else if (jenis === 'file_persyaratan_lain') {
            this.file_5 = blob;
            this.simpanLain();
          } else if (jenis === 'file_persyaratan_reklamasi') {
            this.file_6 = blob;
            this.simpanReklamasi();
          }
        })
        .catch(async (err) => {
          this.$loading(false);

          let message = "Terjadi kesalahan saat mengunduh dokumen.";

          // Jika error terjadi saat responseType adalah 'blob', isi err.response.data berbentuk Blob juga
          if (err.response && err.response.data instanceof Blob) {
            try {
              const errorText = await err.response.data.text();
              const errorJson = JSON.parse(errorText);
              message = errorJson.message || message;
            } catch (e) {
              // Gagal parse JSON dari blob
            }
          } else if (err.response?.data?.message) {
            message = err.response.data.message;
          }

          this.$toasted.error(message);
        });
    },
    nextDokumen() {
      document.getElementById("next").click();
    },
  },
};
</script>

<style src="../Wizard.scss" lang="scss" />